export function getTicketId(): string | null {
  const match = document.cookie.match(/(?:^|; )GPSDK_TKTID=([^;]*)/);
  const value = match?.[1];
  return value !== undefined ? decodeURIComponent(value) : null;
}
